import { createContext, useContext } from 'react';
import type { IAssignedUserModel } from '../models/AssignedUserModel';

export type KanbanView =
  | { type: 'board' }
  | {
      type: 'task-detail';
      taskId: number;
      taskName: string;
      editTaskRouteId: number;
      developersNodeKey?: string;
    };

export interface KanbanViewContextValue {
  view: KanbanView;
  openTaskDetail: (taskId: number, taskName: string) => void;
  openTaskAssignment: (taskId: number, taskName: string, anchorEl: HTMLElement) => void;
  openAssignedUserPreview: (user: IAssignedUserModel, anchorEl: HTMLElement) => void;
  refreshProject: () => void;
  backToBoard: () => void;
}

export const KanbanViewContext = createContext<KanbanViewContextValue>({
  view: { type: 'board' },
  openTaskDetail: () => {},
  openTaskAssignment: () => {},
  openAssignedUserPreview: () => {},
  refreshProject: () => {},
  backToBoard: () => {},
});

export const useKanbanView = () => useContext(KanbanViewContext);
